import { Brand, Model, RepairService, TimeSlot, Review } from '../types/BookingTypes';

// Import single avatar icon
import userAvatar from '../assets/user-avatar.png';
import { ModelReview } from './orderService';

export const brands: Brand[] = [
  { id: 1, name: 'Apple', logo: 'https://readdy.ai/api/search-image?query=minimal%20clean%20apple%20logo%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=80&height=80&seq=1&orientation=squarish' },
  { id: 2, name: 'Samsung', logo: 'https://readdy.ai/api/search-image?query=minimal%20clean%20samsung%20logo%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=80&height=80&seq=2&orientation=squarish' },
  { id: 3, name: 'Google', logo: 'https://readdy.ai/api/search-image?query=minimal%20clean%20google%20logo%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=80&height=80&seq=3&orientation=squarish' },
  { id: 4, name: 'OnePlus', logo: 'https://readdy.ai/api/search-image?query=minimal%20clean%20oneplus%20logo%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=80&height=80&seq=4&orientation=squarish' },
  { id: 5, name: 'Xiaomi', logo: 'https://readdy.ai/api/search-image?query=minimal%20clean%20xiaomi%20logo%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=80&height=80&seq=5&orientation=squarish' },
  { id: 6, name: 'Huawei', logo: 'https://readdy.ai/api/search-image?query=minimal%20clean%20huawei%20logo%20on%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=80&height=80&seq=6&orientation=squarish' },
];

export const models: Model[] = [
  { id: 1, brandId: 1, name: 'iPhone 13 Pro', image: 'https://readdy.ai/api/search-image?query=iphone%2013%20pro%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=60&height=60&seq=7&orientation=squarish' },
  { id: 2, brandId: 1, name: 'iPhone 14', image: 'https://readdy.ai/api/search-image?query=iphone%2014%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=60&height=60&seq=8&orientation=squarish' },
  { id: 3, brandId: 1, name: 'iPhone 15 Pro Max', image: 'https://readdy.ai/api/search-image?query=iphone%2015%20pro%20max%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=60&height=60&seq=9&orientation=squarish' },
  { id: 7, brandId: 1, name: 'iPhone 12', image: 'https://readdy.ai/api/search-image?query=iphone%2012%20on%20clean%20white%20background&width=60&height=60&seq=13&orientation=squarish' },
  { id: 8, brandId: 1, name: 'iPhone 12 Pro', image: 'https://readdy.ai/api/search-image?query=iphone%2012%20pro%20on%20clean%20white%20background&width=60&height=60&seq=14&orientation=squarish' },
  { id: 9, brandId: 1, name: 'iPhone SE (2022)', image: 'https://readdy.ai/api/search-image?query=iphone%20se%202022%20on%20clean%20white%20background&width=60&height=60&seq=15&orientation=squarish' },
  { id: 10, brandId: 1, name: 'iPhone 11', image: 'https://readdy.ai/api/search-image?query=iphone%2011%20on%20clean%20white%20background&width=60&height=60&seq=16&orientation=squarish' },
  { id: 11, brandId: 1, name: 'iPhone XR', image: 'https://readdy.ai/api/search-image?query=iphone%20xr%20on%20clean%20white%20background&width=60&height=60&seq=17&orientation=squarish' },
  { id: 4, brandId: 2, name: 'Galaxy S23 Ultra', image: 'https://readdy.ai/api/search-image?query=samsung%20galaxy%20s23%20ultra%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=60&height=60&seq=10&orientation=squarish' },
  { id: 5, brandId: 2, name: 'Galaxy Z Fold 5', image: 'https://readdy.ai/api/search-image?query=samsung%20galaxy%20z%20fold%205%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=60&height=60&seq=11&orientation=squarish' },
  { id: 6, brandId: 3, name: 'Pixel 8 Pro', image: 'https://readdy.ai/api/search-image?query=google%20pixel%208%20pro%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20studio%20lighting%2C%20simple%20background&width=60&height=60&seq=12&orientation=squarish' },
];

export const repairServices: RepairService[] = [
  { 
    id: 1,
    makeId: 1,
    modelId: 1,
    modelName: "iPhone 13 Pro",
    makeName: "Apple",
    serviceName: 'Screen Replacement',
    serviceImage: 'https://example.com/screen.jpg',
    modelImage: null,
    actualPrice: 149.99,
    markedPrice: 199.99,
    serviceDuration: 120,
    serviceCost: 49.99,
    serviceImagePath: null,
    modelImagePath: null,
    warrantyTypeId: 1,
    warrantyName: 'Screen Warranty',
    warrantyTypeDescription: 'Standard warranty for screen repairs',
    warrantyCoveredItems: 'Display issues;Touch response;Dead pixels',
    warrantyNotCoveredItems: 'Physical damage;Water damage;User modifications',
    warrantyPeriod: 180,
    serviceImageBytes: null
  },
  { 
    id: 2,
    makeId: 1,
    modelId: 1,
    modelName: "iPhone 13 Pro",
    makeName: "Apple",
    serviceName: 'Battery Replacement',
    serviceImage: 'https://example.com/battery.jpg',
    modelImage: null,
    actualPrice: 79.99,
    markedPrice: 99.99,
    serviceDuration: 45,
    serviceCost: 29.99,
    serviceImagePath: null,
    modelImagePath: null,
    warrantyTypeId: 2,
    warrantyName: 'Battery Warranty',
    warrantyTypeDescription: 'Standard warranty for battery replacements',
    warrantyCoveredItems: 'Battery capacity;Charging issues;Battery life',
    warrantyNotCoveredItems: 'Physical damage;Water damage;Unauthorized repairs',
    warrantyPeriod: 180,
    serviceImageBytes: null
  },
  { 
    id: 3,
    makeId: 1,
    modelId: 1,
    modelName: "iPhone 13 Pro",
    makeName: "Apple",
    serviceName: 'Charging Port Repair',
    serviceImage: 'https://example.com/charging.jpg',
    modelImage: null,
    actualPrice: 59.99,
    markedPrice: 79.99,
    serviceDuration: 60,
    serviceCost: 39.99,
    serviceImagePath: null,
    modelImagePath: null,
    warrantyTypeId: 3,
    warrantyName: 'Port Repair Warranty',
    warrantyTypeDescription: 'Standard warranty for charging port repairs',
    warrantyCoveredItems: 'Charging functionality;Data transfer;Port connectivity',
    warrantyNotCoveredItems: 'Physical damage;Water damage;Foreign object damage',
    warrantyPeriod: 90,
    serviceImageBytes: null
  },
  { 
    id: 4,
    makeId: 1,
    modelId: 1,
    modelName: "iPhone 13 Pro",
    makeName: "Apple",
    serviceName: 'Camera Replacement',
    serviceImage: 'https://example.com/camera.jpg',
    modelImage: null,
    actualPrice: 89.99,
    markedPrice: 109.99,
    serviceDuration: 60,
    serviceCost: 44.99,
    serviceImagePath: null,
    modelImagePath: null,
    warrantyTypeId: 4,
    warrantyName: 'Camera Warranty',
    warrantyTypeDescription: 'Standard warranty for camera replacements',
    warrantyCoveredItems: 'Camera functionality;Image quality;Focus issues',
    warrantyNotCoveredItems: 'Physical damage;Water damage;Lens scratches',
    warrantyPeriod: 90,
    serviceImageBytes: null
  },
  { 
    id: 5,
    makeId: 1,
    modelId: 1,
    modelName: "iPhone 13 Pro",
    makeName: "Apple",
    serviceName: 'Water Damage Repair',
    serviceImage: 'https://example.com/water.jpg',
    modelImage: null,
    actualPrice: 129.99,
    markedPrice: 159.99,
    serviceDuration: 180,
    serviceCost: 69.99,
    serviceImagePath: null,
    modelImagePath: null,
    warrantyTypeId: 5,
    warrantyName: 'Water Damage Repair Warranty',
    warrantyTypeDescription: 'Limited warranty for water damage repairs',
    warrantyCoveredItems: 'Component functionality;Corrosion treatment;Board repair',
    warrantyNotCoveredItems: 'Future water damage;Recurring corrosion;Hidden damage',
    warrantyPeriod: 30,
    serviceImageBytes: null
  }
];

export const timeSlots: TimeSlot[] = [
  { id: 1, time: '09:00 AM - 10:00 AM', available: true },
  { id: 2, time: '10:00 AM - 11:00 AM', available: true },
  { id: 3, time: '11:00 AM - 12:00 PM', available: false },
  { id: 4, time: '12:00 PM - 01:00 PM', available: true },
  { id: 5, time: '01:00 PM - 02:00 PM', available: true },
  { id: 6, time: '02:00 PM - 03:00 PM', available: true },
  { id: 7, time: '03:00 PM - 04:00 PM', available: false },
  { id: 8, time: '04:00 PM - 05:00 PM', available: true },
  { id: 9, time: '05:00 PM - 06:00 PM', available: true },
];

const defaultAvatar = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999999'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'/%3E%3C/svg%3E";

export const reviews: ModelReview[] = [
  {
    id: 1,
    customerName: "Rajesh Kumar",
    photoUrl: defaultAvatar,
    rating: 5,
    comment: "Ekdum mast service hai bhai! My OnePlus ka screen was damaged badly but technician fixed it in 1 hour only. 100% genuine parts used. Value for money service 👍",
    createdAt: "03-11-2025", // dd-mm-yyyy format
    modelId: 1  
  },
  {
    id: 2,
    customerName: "Priya Sharma",
    photoUrl: defaultAvatar,
    rating: 4,
    comment: "Very good service but thoda time laga. Samsung S23 ka battery replace kiya, ab full day chalti hai battery without any tension. Technician was very helpful and explained everything properly.",
    createdAt: "04-10-2025", // dd-mm-yyyy format
    modelId: 1
  },
  {
    id: 3,
    customerName: "Abdul Karim",
    photoUrl: defaultAvatar,
    rating: 5,
    comment: "Best service provider in my area! iPhone charging not working tha, within 30 mins repair ho gaya. Reasonable price bhi hai. Definitely recommend karunga 🙏",
    createdAt: "03-03-2025", // dd-mm-yyyy format
    modelId: 1
  },
  {
    id: 4,
    customerName: "Sunita Patel",
    photoUrl: defaultAvatar,
    rating: 5,
    comment: "Bahut badhiya service hai. Redmi phone ka camera kharab ho gaya tha, same day repair kar diya. Technician was very polite and professional. 5 star service ⭐⭐⭐⭐⭐",
    createdAt: "04-03-2025", // dd-mm-yyyy format
    modelId: 1
  },
  {
    id: 5,
    customerName: "Amit Verma",
    photoUrl: defaultAvatar,
    rating: 4,
    comment: "Phone pani me gir gaya tha but minto ne fix kar diya! Thoda expensive tha but service first class hai. Home pickup and delivery bhi free hai. Nice 👌",
    createdAt: "03-03-2025", // dd-mm-yyyy format
    modelId: 1
  }
]; 